import * as constants from '@redbubble/design-system/src/constants';
import RulerIcon from '@redbubble/design-system/src/Icons/Ruler';
import {
  ListContent,
  ListItem,
  ListMedia,
} from '@redbubble/design-system/src/List';
import Text from '@redbubble/design-system/src/Text';
import { useIntl } from '@redbubble/next/intl';
import { ModalSize, useOpenModal } from '@redbubble/next/modals';
import { messages } from '../../../../components/SizeGuide/messages';
import {
  SizeGuideModalContent,
  SizeGuideModalContentLoadingState,
} from '../../../../components/SizeGuide/SizeGuideModalContent';
import { useSizeGuide } from '../../../../components/SizeGuide/SizeGuideProvider';
import styles from './ProductTrustSignals.module.scss';

export interface SizeGuideTrustSignalProps {
  onClick?: () => void;
}

export const SizeGuideTrustSignal: React.FC<SizeGuideTrustSignalProps> = ({
  onClick,
}) => {
  const intl = useIntl();
  const openModal = useOpenModal();
  const { productTypeId, hasSizing, getSizeGuide } = useSizeGuide();

  if (!hasSizing) {
    return null;
  }

  const handleOnClick = async () => {
    onClick?.();
    const { sizeGuideData, initialGender, initialMeasurementUnit } =
      await getSizeGuide();

    openModal({
      accessibleTitle: intl.formatMessage(messages.modalAccessibleTitle),
      content: sizeGuideData ? (
        <SizeGuideModalContent
          sizeGuideData={sizeGuideData}
          initialGender={initialGender}
          initialMeasurementUnit={initialMeasurementUnit}
          productTypeId={productTypeId}
        />
      ) : (
        <SizeGuideModalContentLoadingState />
      ),
      size: ModalSize.Large,
    });
  };

  return (
    <ListItem
      element="a"
      className={styles.pointer}
      onClick={() => handleOnClick()}
      arrow
    >
      <ListMedia>
        <RulerIcon size={constants.LARGE} />
      </ListMedia>
      <ListContent>
        <Text type="display5" display="block">
          {intl.formatMessage(messages.openButtonText)}
        </Text>
        <Text display="block" type="body2">
          {intl.formatMessage(messages.fitIndicatorTitle)}
        </Text>
      </ListContent>
    </ListItem>
  );
};
